export default {
	statusLabels: {
		active: "Active",
		archived: "Archived",
		done: "Completed",
	},
	transparencyLevels: {
		public: "Public",
		private: "Private",
	},
};
